import { render, staticRenderFns } from "./Authorized.vue?vue&type=template&id=73f1e232&scoped=true&"
import script from "./Authorized.vue?vue&type=script&lang=ts&"
export * from "./Authorized.vue?vue&type=script&lang=ts&"
import style0 from "./Authorized.vue?vue&type=style&index=0&id=73f1e232&scoped=true&lang=scss&"
import style1 from "./Authorized.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f1e232",
  null
  
)

export default component.exports